import React, { useState } from 'react';
import { GuideComponent } from './index';

function GuideButton() {
  const [showGuide, setShowGuide] = useState(false);

  const toggleGuide = () => {
    setShowGuide(!showGuide);
  };

  return (
    <div>
      <button 
        onClick={toggleGuide}
        style={{
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          padding: '10px 15px',
          marginLeft: '10px',
          cursor: 'pointer',
          fontWeight: 'bold',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {showGuide ? '关闭使用说明' : '使用说明'}
      </button>
      
      {showGuide && (
        <div className="guide-modal" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px'
        }}>
          <div className="guide-content" style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxWidth: '95%',
            maxHeight: '90%',
            overflow: 'auto',
            position: 'relative'
          }}>
            <button
              onClick={toggleGuide}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer',
                zIndex: 1001
              }}
            >
              ×
            </button>
            <GuideComponent />
          </div>
        </div>
      )}
    </div>
  );
}

export default GuideButton; 